import script from "./PatientAppointmentBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientAppointmentBox.vue?vue&type=script&lang=ts&setup=true"

import "./PatientAppointmentBox.vue?vue&type=style&index=0&id=4c9759f9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9759f9"]])

export default __exports__